import { Box, ButtonGroup, CardContent, Dialog, DialogContent, Divider } from "@material-ui/core";
import { CloudDownload, CloudUpload } from "@material-ui/icons";
import * as FileSaver from "file-saver";
import React, { Fragment, useState, useEffect } from "react";
import {
  Button,
  CreateButton,
  Datagrid,
  EditButton,
  ExportButton,
  Loading,
  ReferenceField,
  TextField,
  TopToolbar,
  useNotify,
  useRefresh,
} from "react-admin";
import FilterToolbar from "../../../Components/FiltersToolbar/FilterToolbar";
import { FilterInputType, FilterTypes } from "../../../Enums/FilterTypes";
import * as XLSX from "xlsx";
import { EnumField } from "../../../Components/EnumField";
import CreatedByField from "../../../Components/ReferenceFields/CreatedBy/CreatedByField";
import { DefaultPerPageSize } from "../../../Constants/Constant";
import { HomebaseStatusType } from "../../../Enums/HomebaseStatusType";
import { SourceCustomer } from "../../../Pages/Admin/Customer";
import { useAppDataProvider } from "../../../dataprovider";
import { TitleHomebaseComponent } from "./Constant/Constant";
import HomebaseComponentDetail from "./HomebaseComponentDetail";
import { ImportExcelInformationDialog } from "./HomebaseCreateBulkReview";
import { CustomDateField } from "../../../Components/CustomDateField";
import PoolList from "../../../Components/PoolListComponent/PoolListComponent";
import { HomebaseComponentDeleteButton } from "./HomebaseComponentDeleteButton";

const HomebaseComponentList = props => {
  const [loading, setLoading] = useState(false);
  const [tempData, setTempData] = useState([] as any);
  const [openPopup, setOpenPopup] = useState(false);
  const [customers, setCustomers] = useState<any>();
  const [warehouseList, setWarehouseList] = useState<any>();
  const notify = useNotify();
  const refresh = useRefresh();
  const dataProvider = useAppDataProvider();

  useEffect(() => {
    GetCustomers();
  }, []);
  const GetCustomers = () => {
    dataProvider
      .getList(SourceCustomer, {
        pagination: { page: 1, perPage: 1000 },
        sort: { field: "customerCode", order: "ASC" },
        filter: {},
      })
      .then(response => {
        setCustomers(response.data);
        GetWarehouseList(response.data);
      });
  };
  const GetWarehouseList = (customerList: any[]) => {
    dataProvider
      .getList("homebasewarehouses", {
        pagination: { page: 1, perPage: 1000 },
        sort: { field: "location", order: "ASC" },
        filter: {},
      })
      .then(response => {
        var list = response.data.map(x => {
          var customer = customerList.find(k => k.id == x.customerId);
          return { ...x, ...{ location: `${x.location} - ${customer?.customerName}` } };
        });
        setWarehouseList(list);
      });
  };
  const ListActions = props => (
    <TopToolbar {...props}>
      <CreateButton basePath={props.basePath} icon={props.icon} label={props.label} />
      <ExportButton
        resource={props.resource}
        sort={props.currentSort}
        filterValues={props.filterValues}
        maxResults={10000}
      />
      <Button onClick={ExportTemplateClickButton} label="Export Template">
        {<CloudDownload />}
      </Button>
      <Button onClick={ImportClickButton} label="Import Excel">
        {<CloudUpload />}
      </Button>
    </TopToolbar>
  );

  const ExportTemplateClickButton = () => {
    const newValues = [
      {
        CustomerCode: "Buraya Customer Code girilmelidir. Örnek: THY-C",
        Warehouse: "Burayada Warehouse girilmelidir ve girilen Customera ait bir depo olmalıdır. Örnek: IST",
        Pn: "Buraya Pn girilmelidir.",
        Sn: "Buraya Sn girilmelidir.",
        Condition: "Buraya Condition girilmelidir.",
      },
    ];
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const fileName = "Homebase Component Import Template";

    const ws = XLSX.utils.json_to_sheet(newValues);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const excelData = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(excelData, fileName + fileExtension);
  };

  const ImportClickButton = () => {
    document.getElementById("fileInput")?.click();
  };

  const fileChange = e => {
    setLoading(true);
    try {
      let file: File = e.target.files[0];
      let fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);
      fileReader.onload = e => {
        let arrayBuffer: any = fileReader.result;
        var data = new Uint8Array(arrayBuffer);
        var arr = new Array();
        for (var i = 0; i != data.length; ++i) {
          arr[i] = String.fromCharCode(data[i]);
        }
        var bstr = arr.join("");
        var workbook = XLSX.read(bstr, { type: "binary" });
        var sheetName = workbook.SheetNames[0];
        var worksheet = workbook.Sheets[sheetName];
        var dataList = XLSX.utils.sheet_to_json(worksheet, { raw: true });
        dataList = dataList.map((x: any) => {
          return {
            ...x,
            ...{
              Condition: x.Condition != null ? `${x.Condition}` : null,
              Pn: x.Pn != null ? `${x.Pn}` : null,
              Sn: x.Sn != null ? `${x.Sn}` : null,
            },
          };
        });
        getExcelTempData(dataList);
      };
    } catch (error) {
      setLoading(false);
      notify(`Failed: ${error}`, "error");
    }
  };

  const ExportToExcel = data => {
    const newValues = data.map(v => ({
      Pn: v.pn,
      Sn: v.sn,
      Status: HomebaseStatusType[v.homebaseStatusEnum],
      CreatedBy: v.createdBy,
      CreatedDate: v.createdDate,
    }));
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const fileName = "Homebase Component List";

    const ws = XLSX.utils.json_to_sheet(newValues);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const excelData = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(excelData, fileName + fileExtension);
  };

  const getExcelTempData = (data: any[]) => {
    setLoading(true);
    dataProvider
      .postHomebaseComponentTempCreate(data)
      .then(response => {
        if (response?.data?.length !== 0) {
          setTempData(response?.data);
        }
        setOpenPopup(true);
        setLoading(false);
      })
      .catch(error => {
        notify(`Failed: ${error.message}`, "error");
        setLoading(false);
      });
  };

  const LoadingPopup = () => {
    return (
      // <Grid>
      <Dialog open={loading}>
        <Divider />
        <DialogContent>
          <Loading loadingPrimary={"Please Wait!"} loadingSecondary={"This process may take a few minutes"} />
        </DialogContent>
      </Dialog>
      // </Grid>
    );
  };

  const Actions = ({ record }) => {
    return (
      <Box style={{ flex: 1, flexDirection: "row" }}>
        <ButtonGroup variant="text" size="small">
          <HomebaseComponentDeleteButton color="primary" />
          <EditButton style={{ marginLeft: 1 }} record={record} color="primary" />
        </ButtonGroup>
      </Box>
    );
  };

  return (
    <>
      <Fragment>
        <CardContent>
          <input
            hidden
            id="fileInput"
            accept=".csv,.xlsv,.xlsx,.msg,application/vnd.ms-outlook"
            type="file"
            onChange={e => fileChange(e)}
          ></input>
          <PoolList
            {...props}
            bulkActionButtons={false}
            title={TitleHomebaseComponent.list}
            perPage={DefaultPerPageSize}
            exporter={ExportToExcel}
            actions={<ListActions />}
            resource="homebasecomponents/getmaindata"
            filters={
              <FilterToolbar
                dataSource={[
                  {
                    source: "customerId",
                    inputType: FilterInputType.Select,
                    label: "Customer",
                    filterTypeChangeDisable: true,
                    filterType: FilterTypes.Equals,
                    choices: customers,
                    optionValue: "id",
                    optionText: "customerName",
                  },
                  {
                    source: "warehouseId",
                    inputType: FilterInputType.Select,
                    label: "Warehouse",
                    filterTypeChangeDisable: true,
                    filterType: FilterTypes.Equals,
                    choices: warehouseList,
                    optionValue: "id",
                    optionText: "location",
                  },
                  {
                    source: "refNo",
                    inputType: FilterInputType.Text,
                    label: "Ref No",
                  },
                  {
                    source: "pn",
                    inputType: FilterInputType.Text,
                    label: "Pn",
                  },
                  {
                    source: "sn",
                    inputType: FilterInputType.Text,
                    label: "Sn",
                  },
                ]}
              />
            }
          >
            <Datagrid expand={<HomebaseComponentDetail />}>
              {<Actions record={props} />}
              <TextField source="refNo" />
              <ReferenceField label="Customer" source="customerId" reference={SourceCustomer} link={false}>
                <TextField source="customerName" />
              </ReferenceField>
              <ReferenceField label="Warehouse" source="warehouseId" reference={"homebasewarehouses"} link={false}>
                <TextField source="location" />
              </ReferenceField>
              <TextField source="pn" />
              <TextField source="sn" />
              <TextField source="condition" />
              <EnumField label={"Status"} enumName={"HomebaseStatusType"} source={"homebaseStatusEnum"} />
              <CreatedByField source="createdBy" link={false} />
              <CustomDateField source="createdDate" showTime />
              <CustomDateField label="Used Date" source="updatedDate" showTime />
            </Datagrid>
          </PoolList>
        </CardContent>
      </Fragment>
      {loading && <LoadingPopup />}
      <ImportExcelInformationDialog
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
        setLoading={setLoading}
        tempData={tempData}
        notify={notify}
        refresh={refresh}
        dataProvider={dataProvider}
      />
    </>
  );
};

export default HomebaseComponentList;
